/**
 * Patient Form State
 * Unified form state structure for both add and edit operations
 */
export interface PatientFormState {
  firstName: string;
  middleName: string;
  lastName: string;
  dob: string;
  gender: '' | 'M' | 'F' | 'O';
  email: string;
  phone: string;
  status: 'PENDING_ADMISSION' | 'ACTIVE' | 'INACTIVE' | 'ON_HOLD';
}

/**
 * Initial form state for resets
 */
export const INITIAL_PATIENT_FORM: PatientFormState = {
  firstName: '',
  middleName: '',
  lastName: '',
  dob: '',
  gender: '',
  email: '',
  phone: '',
  status: 'ACTIVE',
};

/**
 * Gender mapping between API format (M/F/O) and UI format (Male/Female/Other)
 */
export const GENDER_MAP = {
  toUI: (apiCode: string): string => {
    switch (apiCode?.toUpperCase()) {
      case 'M': return 'Male';
      case 'F': return 'Female';
      case 'O': return 'Other';
      default: return apiCode || '';
    }
  },
  toAPI: (uiGender: string): string => {
    switch (uiGender) {
      case 'Male': return 'M';
      case 'Female': return 'F';
      case 'Other': return 'O';
      default: return uiGender || '';
    }
  },
};

/**
 * Validation error list
 */
export type ValidationErrors = string[];
